import {
    Content,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge,
    CarouselContainer,
    FilmSection,
    FilmTitle,
    FilmCaption,
    FilmVideo,
} from './styles';
import { appStoreURL } from '../../constants/urls';
import Carousel, { hasScreenshots } from '../Carousel';

const Home = () => {
    return (
        <>
        <Content $single={!hasScreenshots}>
            <TextContainer>
                <Title>MemoryRoute</Title>
                <SubTitle>Ideas today, memories later.</SubTitle>
                <Description>MemoryRoute catches an idea for a trip or an experience in five seconds, shows you the empty stretches in your calendar while they can still be filled, and keeps what actually happened. No account, no analytics, no subscription.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" alt="Download on the App Store" /></a>
            </TextContainer>
            {hasScreenshots && (
                <CarouselContainer>
                    <Carousel />
                </CarouselContainer>
            )}
        </Content>

        {/* preload="none" on purpose: this is a 76-second film and most visitors will never
            press play. The poster is a still from it, so the section is not a black rectangle
            until they do. */}
        <FilmSection>
            <FilmTitle>See it end to end</FilmTitle>
            <FilmCaption>A minute and a quarter, from catching an idea to sending the story.</FilmCaption>
            <FilmVideo
                controls
                preload="none"
                playsInline
                poster="assets/film-poster.jpg"
            >
                <source src="assets/memoryroute-film.mp4" type="video/mp4" />
                Your browser cannot play this video.
            </FilmVideo>
        </FilmSection>
        </>
    );
}

export default Home;
